<div class="ap-margin-bottom-3">
    {{ 'financial-obligations.mobile-phone-payment.amount' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>
<ap-amount-input
    id="mobilePhonePaymentAmount"
    [helpText]="'financial-obligations.mobile-phone-payment.help-text' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
    [label]="'global.monthly-input.label' | apContent"
></ap-amount-input>

<additional-info
    [key]="questionKey"
    titleKey="financial-obligations.mobile-phone-payment.amount.additional-info.title"
    contentKey="financial-obligations.mobile-phone-payment.amount.additional-info.content"
    modalUrlKey="financial-obligations.mobile-phone-payment.amount.additional-info.title"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
